import { Injectable } from '@angular/core';
import { RelatorioRecebidos } from "../model/relatorioRecebido";
import { environment } from "../../../environments/environment";
import { AuthService } from "../auth/auth.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AbortSignal } from 'abort-controller';
import { paramRecebidos } from "../model/paramRecebidos";
import { MessageService } from 'primeng/api';


@Injectable()
export class RecebidosService {

  private apiUrl = environment.api + environment.recebidos;

  constructor(protected authService:AuthService, protected http: HttpClient,
    private messageService: MessageService) { }

  public async getRecebidos(parametros: paramRecebidos, options?: { signal?: AbortSignal }): Promise<RelatorioRecebidos> {
    console.log('RecebidosService.getRecebidos - Parâmetros recebidos:', parametros);

    const token = await this.authService.getAccessToken();

    const requestOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      ...(options?.signal ? { signal: options.signal } : {})
    };

    let url = this.apiUrl;
    if (parametros.tipo === 'OUTROS') {
      url += '-outros';
    }

    console.log('RecebidosService.getRecebidos - URL da API:', url);

    try {
      console.log('RecebidosService.getRecebidos - Enviando requisição para API...');
      const response = await this.http
        .post<RelatorioRecebidos>(url, parametros, requestOptions)
        .toPromise();

      console.log('RecebidosService.getRecebidos - Resposta recebida:', response);
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('Requisição abortada');
      } else {
        console.error('RecebidosService.getRecebidos - Erro na requisição:', error);
        this.messageService.add({ severity: 'error',  summary: error.error.title, detail: error.error.detail  });
        throw error;
      }
      throw error;
    }
  }
}
